const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_2c1eb65f-a661-481f-98ee-754a9ceda4a7/artifacts/e8s7vgy0_staff.png";

export default function Logo({ className = "h-32 w-auto", showWordmark = true }) {
    return (
        <div className="flex items-center gap-3" data-testid="brand-logo">
            <img
                src={LOGO_URL}
                alt="Staff Flow 360"
                className={className}
                draggable={false}
            />
            {!showWordmark && null}
        </div>
    );
}
